// extracted by mini-css-extract-plugin
module.exports = {"buttonMain":"button_buttonMain__3VI8K","blue":"button_blue__NoN2K","green":"button_green__otko5","small":"button_small__1fOte","medium":"button_medium__1s-5f"};